import { createClassBridgeComponent } from './class-bridge.js';
import { createStatefulComponent } from './stateful-component.js';
function builder(ComponentType, metadata) {
    const name = ComponentType.name;
    const StatefulComponent = createStatefulComponent(`${name}[Stateful]`, ComponentType);
    return createClassBridgeComponent(`${name}[ClassBridge]`, StatefulComponent, metadata);
}
export { builder, };
//# sourceMappingURL=builder.js.map